import { render } from "./VerifiedBadge.vue?vue&type=template&id=7a7f89c4"
import script from "./VerifiedBadge.vue?vue&type=script&lang=js"
export * from "./VerifiedBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__